import { graphql, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import Branded from '../components/Branded';
import SEO from '../components/SEO';
import Footer from '../sections/Footer';

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
`;

/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Page wrapper ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */
const PageWrap = styled.main`
  background: #fff;
  padding: 64px 24px 72px;

  @media (max-width: 768px) {
    padding: 48px 20px 56px;
  }
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Hero ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */
const HeroBanner = styled.section`
  background: #0b1f3a;
  padding: 160px 24px 80px;
  text-align: center;
  animation: ${fadeUp} 0.8s ease both;

  @media (max-width: 768px) {
    padding: 120px 20px 56px;
  }

  .hero-title {
    font-size: clamp(2rem, 4.6vw, 3.6rem);
    font-weight: 700;
    color: #fff;
    line-height: 1.15;
    letter-spacing: -0.01em;
    margin: 0 0 18px;
  }

  .hero-desc {
    /* Brand blue is too dark against the hero overlay */
    .brand-space {
      color: #8fc4f7;
    }

    font-size: 16px;
    color: rgba(255, 255, 255, 0.75);
    line-height: 1.7;
    max-width: 680px;
    margin: 0 auto;

    @media (max-width: 768px) {
      font-size: 14.5px;
    }
  }
`;

/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Top grid: info + map ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */
const TopGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(300px, 1fr) 1.4fr;
  gap: 32px;
  margin-bottom: 56px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 24px;
    margin-bottom: 40px;
  }
`;

const InfoStack = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const InfoCard = styled.div`
  position: relative;
  border: 1px solid #d8e1ec;
  border-radius: 4px;
  padding: 24px 26px 24px 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #fff;
  transition: border-color 0.25s ease, transform 0.25s ease,
    box-shadow 0.25s ease;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 16px;
    bottom: 16px;
    width: 3px;
    background: #f08020;
    border-radius: 0 2px 2px 0;
  }

  &:hover {
    border-color: #1378e5;
    transform: translateY(-2px);
    box-shadow: 0 18px 44px rgba(19, 120, 229, 0.08);
  }

  .info-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #f08020;
    margin-bottom: 8px;
  }

  .info-value {
    font-size: 15px;
    color: #1b2733;
    line-height: 1.55;
    white-space: pre-line;
    word-break: break-word;

    a {
      color: inherit;
      text-decoration: none;
      transition: color 0.25s ease;

      &:hover {
        color: #1378e5;
      }
    }
  }
`;

const MapWrap = styled.div`
  position: relative;
  border: 1px solid #d8e1ec;
  border-radius: 4px;
  overflow: hidden;
  background: #f2f6fc;
  min-height: 360px;

  iframe {
    width: 100%;
    height: 100%;
    min-height: 360px;
    border: 0;
    display: block;
  }

  .map-fallback {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #5b6b7c;
    font-size: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    text-align: center;
    padding: 24px;
  }

  .map-link {
    position: absolute;
    bottom: 16px;
    right: 16px;
    background: #f08020;
    color: #fff;
    font-size: 11px;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    padding: 10px 18px;
    border-radius: 999px;
    text-decoration: none;
    transition: background 0.25s ease;

    &:hover {
      background: #c95e0f;
    }
  }
`;

/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Form section ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */
const FormSection = styled.section`
  border: 1px solid #d8e1ec;
  border-radius: 4px;
  background: #fff;
  padding: 56px 56px;
  display: grid;
  grid-template-columns: minmax(220px, 280px) 1fr;
  gap: 56px;
  margin-bottom: 56px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    padding: 40px 28px;
    gap: 32px;
    margin-bottom: 40px;
  }

  .form-head {
    .form-title {
      font-size: clamp(1.4rem, 2.6vw, 1.9rem);
      font-weight: 700;
      color: #111;
      line-height: 1.2;
      margin: 0 0 14px;
    }

    .form-desc {
      font-size: 14px;
      color: #5b6b7c;
      line-height: 1.7;
      margin: 0;
    }
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .label {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.08em;
    color: #1b2733;
  }

  input,
  textarea,
  select {
    width: 100%;
    border: 0;
    border-bottom: 1.5px solid #d8e1ec;
    background: transparent;
    padding: 12px 0;
    font-size: 15px;
    color: #1b2733;
    font-family: inherit;
    transition: border-color 0.25s ease;
    outline: none;

    &:focus {
      border-bottom-color: #1378e5;
    }

    &::placeholder {
      color: #9fb0c3;
    }
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%239fb0c3'%3E%3Cpath d='M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 4px center;
    background-size: 18px;
    padding-right: 28px;

    option {
      color: #1b2733;
    }
  }

  textarea {
    resize: vertical;
    min-height: 120px;
    line-height: 1.55;
  }
`;

const SubmitBtn = styled.button`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 14px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #fff;
  background: #f08020;
  border: 0;
  border-radius: 999px;
  padding: 16px 40px;
  cursor: pointer;
  transition: background 0.25s ease, opacity 0.25s ease;

  &:hover:not(:disabled) {
    background: #c95e0f;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    width: 14px;
    height: 14px;
    stroke: currentColor;
    fill: none;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;

const FormFeedback = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: ${({ tone }) => (tone === 'error' ? '#c0392b' : '#2d7a4f')};
`;

/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Social ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */
const contactQuery = graphql`
  {
    sanityContactPage {
      heroTitle
      heroSubtitle
      formTitle
      formSubtitle
      seoTitle
      seoDescription
    }
    sanityContactInfoSection {
      addressLabel
      address
      phoneLabel
      phone
      emailLabel
      email
      mapEmbedUrl
      mapDirectionsUrl
    }
  }
`;

const initialForm = {
  name: '',
  phone: '',
  email: '',
  'property name': '',
  location: '',
  'built up': '',
  'property type': '',
};

// Encode form data for Netlify Forms (application/x-www-form-urlencoded)
const encode = data =>
  Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');

export default function ContactPage() {
  const data = useStaticQuery(contactQuery);
  const page = data?.sanityContactPage || {};
  const info = data?.sanityContactInfoSection || {};

  const [values, setValues] = useState(initialForm);
  const [status, setStatus] = useState({ state: 'idle', message: '' });

  const handleChange = e => {
    const { name, value } = e.target;
    setValues(v => ({ ...v, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!values.name || !values.email) {
      setStatus({
        state: 'error',
        message: 'Please fill in at least your name and email.',
      });
      return;
    }

    setStatus({ state: 'submitting', message: '' });
    try {
      const res = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({ 'form-name': 'Enquiry Form', ...values }),
      });

      if (!res.ok) throw new Error('Request failed');

      setStatus({
        state: 'success',
        message:
          "Thanks - we've received your message and will be in touch soon.",
      });
      setValues(initialForm);
    } catch (err) {
      setStatus({
        state: 'error',
        message: 'Something went wrong sending your message. Please try again.',
      });
    }
  };

  const phoneTel = info.phone ? info.phone.replace(/[^\d+]/g, '') : '';

  return (
    <div>
      <SEO
        title={page.seoTitle || 'Contact - Decorzo Space'}
        description={page.seoDescription}
      />

      <HeroBanner>
        <h1 className="hero-title">{page.heroTitle || 'Get in touch'}</h1>
        <Branded as="p" className="hero-desc" text={page.heroSubtitle} />
      </HeroBanner>

      <PageWrap>
        <Container>
          {/* Info + Map */}
          <TopGrid>
            <InfoStack>
              <InfoCard>
                <div className="info-label">
                  {info.addressLabel || 'Office Address'}
                </div>
                <div className="info-value">
                  {info.address || 'Address coming soon'}
                </div>
              </InfoCard>
              <InfoCard>
                <div className="info-label">
                  {info.phoneLabel || 'Contact Number'}
                </div>
                <div className="info-value">
                  {info.phone ? (
                    <a href={`tel:${phoneTel}`}>{info.phone}</a>
                  ) : (
                    'Phone coming soon'
                  )}
                </div>
              </InfoCard>
              <InfoCard>
                <div className="info-label">{info.emailLabel || 'Email'}</div>
                <div className="info-value">
                  {info.email ? (
                    <a href={`mailto:${info.email}`}>{info.email}</a>
                  ) : (
                    'Email coming soon'
                  )}
                </div>
              </InfoCard>
            </InfoStack>

            <MapWrap>
              {info.mapEmbedUrl ? (
                <iframe
                  title="Office location"
                  src={info.mapEmbedUrl}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              ) : (
                <div className="map-fallback">
                  Office Google Maps embed will appear here
                </div>
              )}
              {info.mapDirectionsUrl && (
                <a
                  className="map-link"
                  href={info.mapDirectionsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get Directions
                </a>
              )}
            </MapWrap>
          </TopGrid>

          {/* Form */}
          <FormSection>
            <div className="form-head">
              <h2 className="form-title">
                {page.formTitle || 'Leave a message'}
              </h2>
              {page.formSubtitle && (
                <Branded
                  as="p"
                  className="form-desc"
                  text={page.formSubtitle}
                />
              )}
            </div>

            <Form
              name="Enquiry Form"
              method="POST"
              data-netlify="true"
              data-netlify-honeypot="bot-field"
              onSubmit={handleSubmit}
              noValidate
            >
              {/* Netlify Forms: hidden form name + honeypot for spam */}
              <input type="hidden" name="form-name" value="Enquiry Form" />
              <p hidden>
                <label>
                  Don’t fill this out: <input name="bot-field" />
                </label>
              </p>
              <FieldRow>
                <Field>
                  <span className="label">Name</span>
                  <input
                    name="name"
                    type="text"
                    placeholder="Your name"
                    value={values.name}
                    onChange={handleChange}
                    required
                  />
                </Field>
                <Field>
                  <span className="label">Phone Number</span>
                  <input
                    name="phone"
                    type="tel"
                    placeholder="+60 ..."
                    value={values.phone}
                    onChange={handleChange}
                  />
                </Field>
              </FieldRow>
              <FieldRow>
                <Field>
                  <span className="label">Email</span>
                  <input
                    name="email"
                    type="email"
                    placeholder="you@example.com"
                    value={values.email}
                    onChange={handleChange}
                    required
                  />
                </Field>
                <Field>
                  <span className="label">Project / Property Name</span>
                  <input
                    name="property name"
                    type="text"
                    placeholder="e.g. Sunway Velocity"
                    value={values['property name']}
                    onChange={handleChange}
                  />
                </Field>
              </FieldRow>
              <FieldRow>
                <Field>
                  <span className="label">Location</span>
                  <input
                    name="location"
                    type="text"
                    placeholder="City / area"
                    value={values.location}
                    onChange={handleChange}
                  />
                </Field>
                <Field>
                  <span className="label">Property Built Up (Sq Feet)</span>
                  <input
                    name="built up"
                    type="text"
                    placeholder="e.g. 1200"
                    value={values['built up']}
                    onChange={handleChange}
                  />
                </Field>
              </FieldRow>
              <Field>
                <span className="label">Property Type</span>
                <select
                  name="property type"
                  value={values['property type']}
                  onChange={handleChange}
                >
                  <option value="">Select property type</option>
                  <option value="Residential">Residential</option>
                  <option value="Commercial">Commercial</option>
                  <option value="Kitchens">Kitchens</option>
                  <option value="Offices">Offices</option>
                  <option value="Hotels & Apartments">
                    Hotels &amp; Apartments
                  </option>
                  <option value="Co-Living">Co-Living</option>
                </select>
              </Field>

              <SubmitBtn type="submit" disabled={status.state === 'submitting'}>
                {status.state === 'submitting'
                  ? 'Submitting...'
                  : 'Submit Enquiry'}
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </SubmitBtn>

              {status.message && (
                <FormFeedback tone={status.state}>
                  {status.message}
                </FormFeedback>
              )}
            </Form>
          </FormSection>
        </Container>
      </PageWrap>

      <Footer />
    </div>
  );
}
